import { PersonDataService } from "../../../core/persons.dataservice";
import { RoleTypeDataService } from "../../../core/jobroletypes.dataservice";
import { Ng2StateDeclaration } from "@uirouter/angular";

import { PersonRoleEditComponent } from "./person.role.edit.component";
import { PersonRoleComponent } from "./person.role.component";

export const personRolesEditState: Ng2StateDeclaration = {
    name: "app.resources.persons.roles.edit",
    url: "/{personRoleId:int}",
    views: {
        "main-view@app": {
            component: PersonRoleEditComponent
        }
    },
    resolve: {
        isNew: () => false,
        personRole: [PersonDataService.Id, "$stateParams", function (personsService: PersonDataService, $stateParams) {
            return personsService.getPersonRole($stateParams.personRoleId);
        }],
        person: [PersonDataService.Id, "$stateParams", function (personsService: PersonDataService, $stateParams) {
            return personsService.get($stateParams.personId);
        }],
        roleTypes: [RoleTypeDataService.Id, function (roleDataService: RoleTypeDataService) {
            return roleDataService.getAll();
        }]
    }
};

export const personRolesNewState: Ng2StateDeclaration = {
    name: "app.resources.persons.roles.new",
    url: "/new",
    views: {
        "main-view@app": {
            component: PersonRoleEditComponent
        }
    },
    resolve: {
        isNew: () => true,
        person: [PersonDataService.Id, "$stateParams", function (personsService: PersonDataService, $stateParams) {
            return personsService.get($stateParams.personId);
        }],
        roleTypes: [RoleTypeDataService.Id, function (roleDataService: RoleTypeDataService) {
            return roleDataService.getAll();
        }],
        personRole: ["person", "roleTypes", function (person: Nema.Crew.Model.Person, roleTypes: Nema.Crew.Model.RoleType[]) {
            return <Nema.Crew.Model.PersonRole>{
                PersonId: person.Id,
                RoleTypeId: roleTypes[0].Id
            };
        }]
    }
};

export const personRolesDetailsState: Ng2StateDeclaration = {
    name: "app.resources.persons.roles.detail",
    url: "/{personRoleId:int}",
    views: {
        "main-view@app": {
            component: PersonRoleComponent
        }
    },
    resolve: {
        personRole: [PersonDataService.Id, "$stateParams", function (personsService: PersonDataService, $stateParams) {
            return personsService.getPersonRole($stateParams.personRoleId);
        }],
        roleTypes: [RoleTypeDataService.Id, "$stateParams", function (roleDataService: RoleTypeDataService) {
            return roleDataService.getAll();
        }],
        isNew: function () {
            return false;
        }
    }
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/roles/person.roles.states.ts